"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

var _Dialog = _interopRequireDefault(require("../Dialog/Dialog"));

var _ButtonNew = _interopRequireDefault(require("../ButtonNew/ButtonNew"));

var _Logo = _interopRequireDefault(require("../Logo/Logo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  padding-right: 1rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0 0 1rem 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n  padding: 1rem 0 1rem 0;\n  @media (max-width: 500px) {\n    flex-direction: column;\n    padding: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var contentWrapper = (0, _core.css)(_templateObject());
var buttonWrapper = (0, _core.css)(_templateObject2());
var headerLogoContainer = (0, _core.css)(_templateObject3());
var logoContainer = (0, _core.css)(_templateObject4());

var SandboxIntroDialog = function SandboxIntroDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose;
  return (0, _core.jsx)(_Dialog["default"], {
    open: open,
    onClose: onClose
  }, (0, _core.jsx)("div", {
    css: contentWrapper
  }, (0, _core.jsx)("div", {
    css: headerLogoContainer
  }, (0, _core.jsx)("div", {
    css: logoContainer
  }, (0, _core.jsx)(_Logo["default"], {
    type: "squareLogo"
  })), (0, _core.jsx)("h2", null, "Sandbox is an exploratory data resource")), (0, _core.jsx)("h3", null, "Explore curated collections to see patterns and relationships, then dig deeper into the context."), (0, _core.jsx)("h3", null, "Work with us to prepare and document your dataset, and see it as map layers."), (0, _core.jsx)("div", {
    css: buttonWrapper
  }, (0, _core.jsx)("div", null, (0, _core.jsx)(_ButtonNew["default"], {
    label: "Explore Data",
    onClick: onClose
  })))));
};

SandboxIntroDialog.propTypes = {
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
var _default = SandboxIntroDialog;
exports["default"] = _default;